import { type Dispatch } from "@reduxjs/toolkit";
import packsDataService from "../../../../Licensing/Packs/services/packsDataService";
import { err, got, req } from "../slices/editAccountPackLicenseSlice";

export const fetchAccountPackLicense = (packId: number, accountId: number) => async (dispatch: Dispatch) => {
  dispatch(req());
  try {
    const { data } = await packsDataService.getAccountPackLicense(packId, accountId);
    dispatch(got(data));
  } catch (e) {
    dispatch(err(e as Error));
  }
};
